import React from "react";
import ReportByCustomers from "../../../features/reports/rcs/report-by-customers/components/ReportByCustomers";

const _ReportsByCustomers = () => {
  return (
    <div>
      <h2>Reporte RCS por Clientes</h2>
      <ReportByCustomers />
    </div>
  );
};

export default _ReportsByCustomers;
